import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MenuLink from 'components/molecules/menuLink';
import IconVimeo from 'components/atoms/iconVimeo';
import IconInstagram from 'components/atoms/iconInstagram';
import { menuIn, menuOut } from 'components/utils/animation';
import './styles.css';

class MobileMenu extends Component {
    componentDidUpdate(prevProps, prevState) {
        if (prevProps && prevProps.open !== this.props.open) {
            if (this.props.open) {
                menuIn(this.menuNode);
            } else {
                menuOut(this.menuNode);
            }
        }
    }

    render() {
        let { items } = this.props;
        return (
            <div
                className="MobileMenu"
                ref={div => {
                    this.menuNode = div;
                }}
            >
                {items.map((item, i) => (
                    <div key={i} className="MobileMenu__item">
                        <MenuLink {...item} />
                    </div>
                ))}
                <div className="MobileMenu__social">
                    <a
                        className="MobileMenu__social__vimeo"
                        href="https://vimeo.com/kurtriddell"
                    >
                        <IconVimeo />
                    </a>
                    <a
                        className="MobileMenu__social__instagram"
                        href="https://www.instagram.com/kurtriddell__/"
                    >
                        <IconInstagram />
                    </a>
                </div>
            </div>
        );
    }
}

MobileMenu.propTypes = {
    items: PropTypes.array
};

MobileMenu.defaultProps = {
    items: []
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/organisms/app/mobileMenu/index.js